import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import "./Profile.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getSingleProvider, deleteProvider } from "../services/providerService";
import moment from "moment";
import { useSelector } from "react-redux";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import Modal from "react-bootstrap/Modal";
import reddelete from "../../images/red-Delete.svg";
import Loader from "../../utils/Loader";
import BackButton from "../../utils/BackButton";

function Profile() {
  const { data } = useSelector((state) => state.login);
  const location = useLocation();
  const { provider } = location.state || {};
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [userActive, setUserActive] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [ferchedProvider, setFetchedProvider] = useState({});
  const [deleteModelShow, setDeleteModelShow] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
    }
  };
  const editProfile = (provider) => {
    data.role === "DOCTOR" &&
      navigate("/doctor/provider/edit", { state: { provider: provider } });
    data.role === "ADMIN" &&
      navigate("/admin/provider/edit", { state: { provider: provider } });
    data.role === "PROVIDER" &&
      navigate("/doctor/provider/edit", { state: { provider: provider } });
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const handleToggle = () => {
    setUserActive(!userActive);
  };

  const checkProviderDetails = async () => {
    setLoading(true);
    const data = await getSingleProvider(provider);

    if (data) {
      setFetchedProvider(data);
    }
    setLoading(false);
  };

  const redirectToResetpass = async () => {
    data.role === "DOCTOR" &&
      navigate("/doctor/update/password", { state: { provider: provider } });
    data.role === "ADMIN" &&
      navigate("/admin/update/password", { state: { provider: provider } });
  };

  useEffect(() => {
    if (!provider) {
      navigate("/admin/provider/listing");
      return;
    }
    checkProviderDetails();
  }, [provider]);

  const colors = [
    "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    "#e9c183", // light Orange
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="profile-area">
            <div className="button-block profile-pg d-flex gap-3 align-items-center mt-0">
              <BackButton className="" />

              {data._id == ferchedProvider._id && (
                <Button className="outlined-btn" onClick={redirectToResetpass}>
                  Change Password
                </Button>
              )}
            </div>
            <div className="profile-block">
              <div className="upper-block flex-wrap">
                <div className="img-text-block">
                  <div className="image-upload-box">
                    <div className="profile_main d-flex justify-content-between align-items-center flex-wrap">
                      <div className="profile_info flex-wrap">
                        <div className="img_block">
                          <div className="img_profile_container">
                            <div
                              className="patient-initials"
                              style={{
                                background:
                                  colors[
                                  Math.floor(Math.random() * 5) +
                                  (1 % colors.length)
                                  ],
                              }}
                            >
                              {`${ferchedProvider?.firstName?.[0] || ""}${ferchedProvider?.lastName?.[0] || ""
                                }`.toUpperCase()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="name">
                    {ferchedProvider?.name}
                    <span className="email-id"> {ferchedProvider?.email}</span>
                  </div>
                </div>
                {data._id == ferchedProvider._id ? (
                  <div className="edit-profilebtn mt-3">
                    <button
                      className="edit-del-icon edit-del-icon-profile outlined-btn btn btn-primary p-2"
                      onClick={() => editProfile(provider)}
                    >
                      <img src={editicon} alt="Edit" />
                    </button>
                  </div>
                ) : (
                  (data.role == "ADMIN" || data.role == "PROVIDER") && (
                    <div className="edit-profilebtn mt-3 d-flex gap-2 ">
                      <button
                        className="edit-del-icon edit-del-icon-profile outlined-btn btn btn-primary p-2"
                        onClick={() => setDeleteModelShow(true)}
                      >
                        <img src={binicon} alt="delete" />
                      </button>
                    </div>
                  )
                )}
              </div>
              <div className="lower-block">
                <div className="lower-block-inner-wrapper provider-detail-grid">
                  <dl>
                    <dt className="doc-info">Phone Number</dt>
                    <dd className="doc-profile-info">{ferchedProvider?.primaryPhone}</dd>
                  </dl>
                  <dl>
                    <dt className="doc-info">Date of Birth</dt>
                    <dd className="doc-profile-info">{moment(ferchedProvider?.dob).format("MM/DD/YYYY")}</dd>
                  </dl>
                  <dl>
                    <dt className="doc-info">Gender</dt>
                    <dd className="doc-profile-info">{ferchedProvider?.gender}</dd>
                  </dl>
                  <dl>
                    <dt className="doc-info">Date of Joined</dt>
                    <dd className="doc-profile-info">{moment(ferchedProvider?.createdAt).format("MM/DD/YYYY")}</dd>
                  </dl>
                  <dl>
                    <dt className="doc-info">Invite Code</dt>
                    <dd className="doc-profile-info">{ferchedProvider?.invideCode || "-"}</dd>
                  </dl>
                </div>
              </div>
              <div className="about-doctor">
                <span className="doc-info">About Doctor</span>
                <p className="mb-0">{ferchedProvider?.about || "-"}</p>
              </div>
            </div>
          </div>

          {/* delete patient modal */}
          <Modal
            className="dlt-patient-modal"
            show={deleteModelShow}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={() => setDeleteModelShow(false)}
          >
            <Modal.Body>
              <div className="d-flex justify-content-center mb-3">
                <div className="delete-img">
                  <img src={reddelete} alt="img"></img>
                </div>
              </div>
              <h4>Are you sure? </h4>
              <p>You want to detele this doctor</p>
              <div className="authentication-btns d-flex justify-content-center gap-4">
                <Button
                  className="btn border-btn btn-no outlined-btn"
                  onClick={() => setDeleteModelShow(false)}
                >
                  No
                </Button>
                <Button
                  className="btn dark-btn btn-yes"
                  onClick={async () => {
                    setDeleteModelShow(false);
                    await deleteProvider(provider);

                    navigate(`/admin/provider/listing`);
                  }}
                >
                  Yes
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}

export default Profile;
